/**
 * @generated SignedSource<<008d7eff8fd3fb11036a07b078c81c06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_navigationKitTabListOld_TabList$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly isDefault: boolean;
      readonly typeKey: JiraNavigationItemTypeKey | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"jiraTab_navigationKitTabListOld">;
    };
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ui_navigationKitTabListOld_TabList";
};
export type ui_navigationKitTabListOld_TabList$key = {
  readonly " $data"?: ui_navigationKitTabListOld_TabList$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabListOld_TabList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_navigationKitTabListOld_TabList",
  "selections": [
    {
      "concreteType": "JiraNavigationItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "id"
                },
                "action": "THROW",
                "path": "edges.node.id"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "isDefault"
                },
                "action": "THROW",
                "path": "edges.node.isDefault"
              },
              {
                "kind": "ScalarField",
                "name": "typeKey"
              },
              {
                "kind": "FragmentSpread",
                "name": "jiraTab_navigationKitTabListOld"
              }
            ]
          },
          "action": "THROW",
          "path": "edges.node"
        }
      ]
    }
  ],
  "type": "JiraNavigationItemConnection"
};

(node as any).hash = "13af948a91b2cf429d4bfff91d3847f2";

export default node;
